import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const Home = lazy(() => import("./views/Home"));
const NosActionsRse = lazy(() => import("./views/NosActionsRse"));
const NosPerformances = lazy(() => import("./views/NosPerformances"));
const NosChiffresCles = lazy(() => import("./views/NosChiffresCles"));
const NotrePatrimoine = lazy(() => import("./views/NotrePatrimoine"));
// const MentionsLegales = lazy(() => import("./views/MentionsLegales"));

const Routes = () => {
    return (
        <Switch>
            <Route exact path="/" component={Home} />
            <Route
                path="/nos_actions_rse"
                render={(props) => {
                    return <NosActionsRse />;
                }}
            />
            <Route
                path="/nos_performances"
                render={(props) => {
                    return <NosPerformances {...props} />;
                }}
            />
            <Route
                path="/notre_patrimoine"
                render={(props) => {
                    return <NotrePatrimoine />;
                }}
            />
            <Route
                path="/nos_chiffres_cles"
                render={(props) => {
                    return <NosChiffresCles />;
                }}
            />

            <Route
                path="/mentions_legales"
                render={(props) => {
                    return <MentionsLegales />;
                }}
            />
        </Switch>
    );
};
export default Routes;
